import UnderDevelopmentSection from "../component/UnderDevelopmentSection";

export default function UnderDevelopmentPage() {
  return (
    <main>
      <UnderDevelopmentSection />
    </main>
  );
}
